document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.featured-product-scroll').forEach((section) => {
    const container = section.querySelector('.featured-product-scroll__container');
    const prev = section.querySelector('.featured-product-scroll__prev');
    const next = section.querySelector('.featured-product-scroll__next');

    if (!container || !prev || !next) return;

    const updateButtons = () => {
      const hasOverflow = container.scrollWidth > container.clientWidth;

      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;

      if (!hasOverflow) return;

      prev.disabled = container.scrollLeft <= 0;
      next.disabled =
        container.scrollLeft >= container.scrollWidth - container.clientWidth - 1;
    };

    prev.addEventListener('click', () => {
      container.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', () => {
      container.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    });

    container.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    updateButtons();
  });
});